export const ProductionReport = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Z A',
  borderBottom: '1px solid inkBorder',
  flexWrap: 'wrap',
  ProviderName: { text: (el, s) => s.providerName || 'Dr. Smith', fontSize: 'Z', fontWeight: '600', color: 'inkText', minWidth: 'E' },
  ProcedureCount: { text: (el, s) => (s.procedureCount || '0') + ' procedures', fontSize: 'Z', color: 'inkMuted', minWidth: 'D' },
  GrossProduction: { text: (el, s) => s.grossProduction || '$0', fontSize: 'Z', fontWeight: '600', color: 'inkText', minWidth: 'D' },
  NetProduction: { text: (el, s) => s.netProduction || '$0', fontSize: 'Z', color: 'teal', fontWeight: '600', minWidth: 'D' },
  CollectionRate: { text: (el, s) => (s.collectionRate || '0') + '%', fontSize: 'Z', fontWeight: '700', color: 'green', minWidth: 'C' },
  BreakdownBar: {
    flow: 'x',
    flex: '1',
    height: 'Y',
    round: 'B',
    overflow: 'hidden',
    minWidth: 'E',
    Preventive: { height: '100%', background: 'teal', width: (el, s) => (s.preventive || '20') + '%' },
    Restorative: { height: '100%', background: 'purple', width: (el, s) => (s.restorative || '25') + '%' },
    Endo: { height: '100%', background: 'amber', width: (el, s) => (s.endo || '15') + '%' },
    Perio: { height: '100%', background: 'blue', width: (el, s) => (s.perio || '15') + '%' },
    Prosth: { height: '100%', background: 'gold', width: (el, s) => (s.prosth || '15') + '%' },
    Surgery: { height: '100%', background: 'green', width: (el, s) => (s.surgery || '10') + '%' }
  }
}
